import type { Visitor } from '@/lib/types/visitor';
import { VisitorType } from '@/lib/types/visitor';
import { type Ref } from 'vue';

export function useVisitorForm(
    visitor: Visitor,
    selectedErpCustomer: Ref<any>
) {
    function resetVisitor() {
        Object.assign(visitor, {
            id: '',
            firstName: '',
            lastName: '',
            email: '',
            type: VisitorType.NonProfessional,
            erpCode: null,
            representsPurchaseGroup: null,
            commercialSegment: null,
            functionaryId: null,
            agentId: null,
            country: null,
            businessName: null,
            role: null,
            activitySector: null
        });
        selectedErpCustomer.value = null;
    }

    function getVisitorSummary(): string {
        if (visitor.type === VisitorType.ErpProfessional && selectedErpCustomer.value) {
            return selectedErpCustomer.value.name;
        } else if (visitor.firstName || visitor.lastName) {
            return `${visitor.firstName} ${visitor.lastName}`.trim() || '-';
        }
        return '-';
    }

    function handleVisitorTypeChange(newType: VisitorType, oldType: VisitorType) {
        if (newType !== oldType) {
            visitor.erpCode = null;
            visitor.representsPurchaseGroup = null;
            visitor.commercialSegment = null;
            visitor.functionaryId = null;
            visitor.agentId = null;
            visitor.country = null;
            visitor.businessName = null;
            visitor.role = null;
            visitor.activitySector = null;
            selectedErpCustomer.value = null;

            if (oldType === VisitorType.ErpProfessional) {
                visitor.firstName = '';
                visitor.lastName = '';
                visitor.email = '';
            }
        }
    }

    return {
        resetVisitor,
        getVisitorSummary,
        handleVisitorTypeChange
    };
}
